import { ArhivskaDokumentiDialogComponent } from './../../../../../arhivska-knjiga/src/lib/arhivska-knjiga-menu-page/arhivska-does-not-exists-page/arhivska-dokumenti-dialog/arhivska-dokumenti-dialog.component';
import { ArhivskaKnjigaClient, PodesavanjaArhivskeDokumentacijeDto, ArhivskaKnjigaDopisVrsta } from './../../../../../../data-api/src/lib/eKompanija-api';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { IPodesavanjaArhivskeDokumentacijeDto } from '@kodit/core/data-api';
import { AlertService, SharedService } from '@kodit/core/services';
import { DynamicDialogConfig, DynamicDialogService } from '@kodit/core/shared-ui';
import { DialogSize } from 'libs/core/shared-ui/src/lib/dialogs/dynamic-dialog/dynamicdialog-config';
import { Subscription } from 'rxjs';
import { DokumentacijaArhivskeFormComponent } from '../dokumentacija-arhivske-form/dokumentacija-arhivske-form.component';

@Component({
  selector: 'kodit-dokumentacija-arhivske-podesavanja',
  templateUrl: './dokumentacija-arhivske-podesavanja.component.html',
  styleUrls: ['./dokumentacija-arhivske-podesavanja.component.scss']
})
export class DokumentacijaArhivskePodesavanjaComponent implements OnInit, OnDestroy {

  private _subs: Subscription = new Subscription();
  dialogConfig: DynamicDialogConfig = new DynamicDialogConfig(DialogSize.SMALL);
  podesavanjaArhivskeDokumentacijeDto: IPodesavanjaArhivskeDokumentacijeDto;
  public dopisVrsta = ArhivskaKnjigaDopisVrsta;
  disableButton = true;

  constructor(
    private _dialogService: DynamicDialogService,
    private _alertService: AlertService,
    private _client: ArhivskaKnjigaClient,
    private _sharedService: SharedService,
  ) { }

  ngOnInit(): void {
    this.load();
  }

  private load(): void {
    this._subs.add(
      this._client.getPodesavanjaArhivskeDokumentacija().subscribe(
        (result) => {
          this.podesavanjaArhivskeDokumentacijeDto = result.data;
          if(Object.values(result.data).some(value => value === null)){
            this.disableButton = true;
          }else{
            this.disableButton = false;
          }
        },
        (error) => {
          this._subs.add(
            error.subscribe((x: string) => {
              this._alertService.addFailedMsg(x);
            })
          );
        }
      )
    );
  }

  onEdit() {
    this.dialogConfig.header = 'Podešavanja dokumentacije';
    this.dialogConfig.customSubmitButton = {
      label: 'Sačuvaj',
      icon: 'fas fa-download',
    };
    this.openDialog(this.dialogConfig);
  }

  openDialog(config: DynamicDialogConfig): void {
    const ref = this._dialogService.open(
      DokumentacijaArhivskeFormComponent,
      config
    );

    this._subs.add(
      ref.onClose.subscribe((dto: IPodesavanjaArhivskeDokumentacijeDto) => {
        if (dto) {
          this.podesavanjaArhivskeDokumentacijeDto = dto;
          this.disableButton = false;
        }
      })
    );
  }

  preuzmiDopis(type: ArhivskaKnjigaDopisVrsta): void{
    this._subs.add(
      this._client
        .getDopisArhivske(type)
        .subscribe((res) => {
          this._sharedService.downloadBlob(res.data, res.fileName, res.data.type);
        })
      );
  }

  preuzmiDokumentaciju() {
    this.dialogConfig.header = 'Podaci za generisanje dokumenta';
    this.dialogConfig.customSubmitButton = {
      label: 'Preuzmi',
      icon: 'fas fa-download',
    };

    const ref = this._dialogService.open(
      ArhivskaDokumentiDialogComponent,
      this.dialogConfig
    );
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

}
